import { Component, ViewChild, TemplateRef, ElementRef, OnInit } from '@angular/core';
import { IDropdownSettings } from 'ng-multiselect-dropdown';
import { AppService } from '../../app.service';
import { Router } from '@angular/router';
import { SuccessSnackbarComponent } from '../../support/success-snackbar/success-snackbar.component';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { PaginationService } from '../../PaginationService';
import { DynamicAuditTrailComponent } from 'src/app/support/dynamic-audit-trail/dynamic-audit-trail.component';
import { messageService } from 'src/app/message.service';
import { ExcelPdfComponent } from 'src/app/support/excel-pdf/excel-pdf.component';
import { MatSelect } from '@angular/material/select';
import { MatOption } from '@angular/material/core';
import { GridReorderComponent } from 'src/app/grid-reorder/grid-reorder.component';

@Component({
  selector: 'app-qms-notification-settings',
  templateUrl: './qms-notification-settings.component.html',
  styleUrls: ['./qms-notification-settings.component.scss']
})
export class QmsNotificationSettingsComponent implements OnInit {

  isProcessing = true;
  dropDownDataForModule: any = [];
  groupDataList: any = [];
  auditTrail: any = {};
  visibleAuditTrail: boolean = false;
  oddModuleValue: any = null;
  oddModuleType: any = null;

  constructor(public dialog: MatDialog, private readonly appService: AppService, public router: Router, private readonly snackBar: MatSnackBar, public message: messageService,
    public paginationService: PaginationService, private readonly elem: ElementRef) { }

  ngOnInit() {
    this.dropDownDataForModule = JSON.parse(sessionStorage.getItem('dropDownForModules') || '{}');
    this.dropDownForModules = JSON.parse(sessionStorage.getItem('dropDownForModules') || '{}');
    this.selectBoxeForModuleValue();
    this.selectBoxForModule();
    this.getCall();
  }

  refreshGridData() {
    this.getCall();
  }

  qmsNotificationSettingsFieldData: any = {};
  operationFlag: any;
  popupTitle: any;
  @ViewChild('addAndEditPopup', { static: true }) addAndEditPopup: TemplateRef<any>;
  @ViewChild('deletePopup', { static: true }) deletePopup: TemplateRef<any>;

  visibleAddAndEditPopup: MatDialogRef<TemplateRef<any>>;
  visibleDeletePopup: MatDialogRef<TemplateRef<any>>;

  addAndEditPopupConfig = {
    width: '100%',
    height: '90%',
    panelClass: 'my-dialog',
    hasBackdrop: true,
    disableClose: true,
    position: { top: '10px' },
  };

  deletePopupConfig = {
    width: '600px',
    height: 'auto',
    panelClass: 'my-dialog',
    hasBackdrop: false,
    disableClose: true,
    position: { top: '10px' },
  };

  singleSelectDropdownSetting: IDropdownSettings = {
    idField: 'valueExp',
    textField: 'displayExp',
    enableCheckAll: false,
    allowSearchFilter: true,
    singleSelection: true,
    itemsShowLimit: 1,
    closeDropDownOnSelection: true,
  };

  multipleSelectDropdownSetting: IDropdownSettings = {
    idField: 'valueExp',
    textField: 'displayExp',
    enableCheckAll: true,
    allowSearchFilter: true,
    //singleSelection: false,
    itemsShowLimit: 2,
  };

  validateNoOfDigitsFields(event: KeyboardEvent) {
    const forbiddenKeys = ['E', 'e', '-', '*', '+', '.'];
    if (forbiddenKeys.includes(event.key)) {
      event.preventDefault();
    }
  }

  selectedMainModuleValue: any = null;
  moduleValueDropdown: any = [];
  selectedModuleValue: any = null;
  moduleListDropdown: any = [];
  selectedGroupList: any = [];
  groupListDropdown: any = [];
  selectedModuleType: any = null;
  moduleTypeListDropdown: any = [];
  dropDownForModules: any = [];

  /*   public objectComparisonFunction = function( option:any, value :any) : boolean {
      return option.valueExp == value.valueExp;
    }; */

  focusSearch(value: any) {
    setTimeout(() => {
      let searchBox = document.getElementById(value);
      searchBox?.focus();
    }, 0)
  }

  focusmethod(value: any) {
    setTimeout(() => {
      let requiredElement = document.getElementById(value);
      requiredElement?.focus();
    }, 0)
  }
  selectBoxeForModuleValue() {
    this.moduleValueDropdown = [];
    for (const item of this.dropDownForModules) {
      if (item.codelistName !== "Trainings" && item.codelistName !== "Documents") {
        this.moduleValueDropdown.push({
          valueExp: item.codelistCode,
          displayExp: item.codelistName
        });
      }
    }
  }

  selectBoxForModule() {
    this.moduleListDropdown = [];
    for (const item of this.dropDownDataForModule) {
      if (item.codelistName !== 'Trainings' && item.codelistName !== 'Documents') {
        this.moduleListDropdown.push({
          valueExp: item.codelistCode,
          displayExp: item.codelistName
        });
      }
    }
  }

  selectBoxeForGroupValue() {
    this.groupListDropdown = [];
    for (const item of this.groupDataList) {
      this.groupListDropdown.push({
        valueExp: item.groupId,
        displayExp: item.groupName
      });
    }
  }

  selectBoxeForModuleTypeValue() {
    this.moduleTypeListDropdown = [];
    for (const item of this.listOfModuleTypes) {
      this.moduleTypeListDropdown.push({
        valueExp: item.codelistCode,
        displayExp: item.codelistName
      });
    }
  }


  mainModulesearchTxt: any;

  onMainModuleSelect(event: any, item: any) {
    if (event.isUserInput) {
      this.isModuleInvalid = false;
      if (event.source._selected) {
        if (item) {
          this.selectedMainModuleValue = item.valueExp;
          this.mainModuleFieldValue = document.getElementById('main-module-validation') as HTMLInputElement;
          this.mainModuleFieldValue.style.color = '';
          this.isProcessing = true;
          this.getCall();
          this.selectedGroupList = [];
          this.selectedModuleType = null;

          if (item.valueExp != 'CC') {
            this.appService.getCodeListsByGroup(item.valueExp + "_TYPE").subscribe({
              next: (data1: any) => {
                this.listOfModuleTypes = data1;
                this.selectBoxeForModuleTypeValue();
                this.isProcessing = false;
              }, error: (error) => {
                this.isProcessing = false;
              }
            })
          }

          this.appService.getQmsGroupsByModule(item.valueExp).subscribe({
            next: (data2: any) => {
              this.groupDataList = data2;
              this.selectBoxeForGroupValue();
              this.isProcessing = false;
            }, error: (error) => {
              this.isProcessing = false;
            }
          })
        } else {
          this.mainModuleFieldValue = document.getElementById('main-module-validation') as HTMLInputElement;
          this.mainModuleFieldValue.style.color = 'red';
        }
      } else {
        this.selectedMainModuleValue = undefined;
      }
    }
  };

  onMainModuleRemoved(item: any) {
    this.mainModuleFieldValue = document.getElementById('main-module-validation') as HTMLInputElement;
    this.mainModuleFieldValue.style.color = 'red';
  }

  listOfModuleTypes: any = [];


  modulesearchTxt: any;
  onModuleSelect(event: any, item: any) {
    if (event.isUserInput) {
      if (event.source._selected) {
        if (item) {
          this.selectedModuleValue = item.valueExp;
          this.isProcessing = true;


          if (this.moduleFieldValue != undefined) {
            this.moduleFieldValue.style.color = '';
          }
        } else {
          this.groupListDropdown = [];
          this.selectedGroupList = [];
          this.moduleTypeListDropdown = [];
          this.selectedModuleType = null;
          if (this.moduleFieldValue != undefined) {
            this.moduleFieldValue.style.color = 'red';
          }
        }
      }
      this.selectedModuleValue = undefined;
    }
  }

  onModuleRemoved(item: any) {
    this.groupListDropdown = [];
    this.selectedGroupList = [];
    this.moduleTypeListDropdown = [];
    this.selectedModuleType = null;
    if (this.moduleFieldValue != undefined) {
      this.moduleFieldValue.style.color = 'red';
    }
  }
  @ViewChild('groupList') groupList: MatSelect;
  isGroupListSelected = false;

  toggleAllSelection(value: any) {
    if (value == 'groupList') {
      if (this.isGroupListSelected) this.groupList.options.forEach((item: MatOption) => item.select());
      else this.groupList.options.forEach((item: MatOption) => item.deselect());
    }

  }

  groupListSearchText: any;
  onGroupListSelect(event: any, item: any) {
    if (event.isUserInput) {
      setTimeout(() => { this.isGroupListSelected = this.groupListDropdown.length == this.selectedGroupList.length; })
    }
  }

  moduleTypesearchTxt: any;
  onModuleTypeSelect(event: any, item: any) {
    if (event.isUserInput) {
      if (event.source._selected) {
        if (item) {
          this.selectedModuleType = item.valueExp;
          if (this.moduleTypeFieldValue != undefined) {
            this.moduleTypeFieldValue.style.color = '';
          }
        }
      }
      this.selectedModuleType = undefined;

    }
  }

  onModuleTypeRemoved(item: any) {
    if (this.moduleTypeFieldValue != undefined) {
      this.moduleTypeFieldValue.style.color = 'red';
    }
  }

  visibleAddButton: boolean;
  visibleEditButton: boolean;
  mainModuleFieldValue: any;
  openAddPopup() {
    this.mainModuleFieldValue = document.getElementById('main-module-validation') as HTMLInputElement;
    if (this.selectedMainModuleValue) {
      this.visibleAddButton = true;
      this.visibleEditButton = false;
      this.operationFlag = 'ADD';
      this.popupTitle = "Create Quality Notification Settings";
      if (this.selectedMainModuleValue) {
        const matchingModule = this.dropDownDataForModule?.find((item: any) => item.codelistCode == this.selectedMainModuleValue);
        if (!matchingModule) {
          this.moduleListDropdown.push({
            valueExp: this.selectedMainModuleValue,
            displayExp: this.selectedMainModuleValue
          })
        }
        this.selectedModuleValue = this.selectedMainModuleValue;
      }

      this.qmsNotificationSettingsFieldData = {};
      this.selectedGroupList = [];
      setTimeout(() => { this.isGroupListSelected = this.groupListDropdown.length == this.selectedGroupList.length; })
      this.selectedModuleType = null;
      this.qmsNotificationSettingsFieldData.stopEmails = false;
      this.visibleAddAndEditPopup = this.dialog.open(this.addAndEditPopup, this.addAndEditPopupConfig);
    } else {
      alert("Please select the module...");
      this.mainModuleFieldValue.style.color = 'red';
    }
  }

  editNotificationId: any;
  openEditPopup(editRowData: any) {
    this.isProcessing = true;
    this.preparePopupState('EDIT', "Update Quality Notification Settings");
    this.editNotificationId = editRowData.NOTIFICATION_ID;

    // Level 1: Get Initial Details
    this.appService.getQmsNotificationSettingsByNotificationId(editRowData.NOTIFICATION_ID).subscribe((response: any) => {
      this.handleEditDetailsResponse(response);
    });

    this.visibleAddAndEditPopup = this.dialog.open(this.addAndEditPopup, this.addAndEditPopupConfig);
  }

  private handleEditDetailsResponse(response: any): void {
    this.qmsNotificationSettingsFieldData = response;
    this.qmsNotificationSettingsFieldData.stopEmails = response.stopEmails === "Y";

    this.handleModuleSync(this.qmsNotificationSettingsFieldData.module);

    // Level 1: Get Dependent Data (Groups and Types)
    this.appService.getQmsGroupsByModule(
      this.qmsNotificationSettingsFieldData.module
    ).subscribe({
      next: (groups: any) => this.loadSecondaryEditData(groups),
      error: () => this.isProcessing = false
    });
  }

  private loadSecondaryEditData(groups: any): void {
    this.groupDataList = groups;

    // Level 1: Get Module Types
    const typeKey = this.qmsNotificationSettingsFieldData.module + "_TYPE";
    this.appService.getCodeListsByGroup(typeKey).subscribe((types: any) => {
      this.listOfModuleTypes = types;

      // Finalize UI
      this.selectBoxeForGroupValue();
      this.selectBoxeForModuleTypeValue();
      this.initializeEditDropdownSelections();

      this.isProcessing = false;
    });
  }

  private initializeEditDropdownSelections(): void {
    // Logic for Group List
    if (this.qmsNotificationSettingsFieldData.groupList) {
      this.selectedGroupList = this.qmsNotificationSettingsFieldData.groupList.split(',').map(Number);
      this.refreshGroupSelectionStatus();
    }

    // Logic for Module Type
    const mType = this.qmsNotificationSettingsFieldData.moduleType;
    if (mType) {
      this.syncModuleType(mType);
      this.selectedModuleType = mType;
    }
  }

  private refreshGroupSelectionStatus(): void {
    setTimeout(() => {
      this.isGroupListSelected = this.groupListDropdown.length === this.selectedGroupList.length;
    });
  }

  private handleModuleSync(module: string): void {
    if (!module) return;

    const matchingModule = this.dropDownDataForModule?.find(
      (item: any) => item.codelistCode === module
    );

    if (!matchingModule) {
      this.oddModuleValue = module;
      this.moduleListDropdown.push({
        valueExp: module,
        displayExp: module
      });
    }

    this.selectedModuleValue = module;
  }

  private syncModuleType(moduleType: string): void {
    const matchingModuleType = this.listOfModuleTypes?.find(
      (item: any) => item.codelistCode === moduleType
    );

    if (!matchingModuleType) {
      this.oddModuleType = moduleType;
      this.moduleTypeListDropdown.push({
        valueExp: moduleType,
        displayExp: moduleType
      });
    }
  }

  // Small helper to reset UI state
  private preparePopupState(flag: string, title: string): void {
    this.visibleAddButton = false;
    this.visibleEditButton = true;
    this.operationFlag = flag;
    this.popupTitle = title;
    this.selectedModuleValue = null;
    this.selectedGroupList = [];
    this.selectedModuleType = null;
  }
  moduleFieldValue: any;
  groupListFieldValue: any;
  moduleTypeFieldValue: any;
  updateValue: any;
  fieldValidation() {
    this.moduleFieldValue = document.getElementById('module-validation') as HTMLInputElement;
    this.groupListFieldValue = document.getElementById('groupList-validation') as HTMLInputElement;
    this.moduleTypeFieldValue = document.getElementById('moduleType-validation') as HTMLInputElement;
    this.updateValue = document.getElementById('update-validation') as HTMLInputElement;

    if (this.selectedModuleValue) {
      this.moduleFieldValue.style.color = '';
    } else {
      this.moduleFieldValue.style.color = 'red';
    }

    if (this.visibleEditButton) {
      if (this.qmsNotificationSettingsFieldData.updateReason) {
        this.updateValue.style.color = '';
      } else {
        this.updateValue.style.color = 'red';
      }
    }

    if (this.selectedGroupList.length) {
      this.groupListFieldValue.style.color = '';
    } else {
      this.groupListFieldValue.style.color = 'red';
    }

    if (this.selectedMainModuleValue != 'CC') {
      if (this.selectedModuleType) {
        this.moduleTypeFieldValue.style.color = '';
      } else {
        this.moduleTypeFieldValue.style.color = 'red';
      }
    }

  }

  onFieldFocusout() {
    this.deleteReasonFieldValue = document.getElementById('deleteReason-validation') as HTMLInputElement;

    if (this.deleteReasonFieldValue != undefined) {
      if (this.qmsNotificationSettingsFieldData.deleteReason == "" || this.qmsNotificationSettingsFieldData.deleteReason == undefined) {
        this.deleteReasonFieldValue.style.color = 'red';
      } else {
        this.deleteReasonFieldValue.style.color = '';
      }
    }
  }

  addAndEditFunction(fieldData: any) {
    this.isProcessing = true;

    if (!this.isValidForm()) {
      this.fieldValidation();
      alert('Please enter all mandatory fields...');
      this.isProcessing = false;
      return;
    }

    const payload = this.preparePayload(fieldData);

    if (this.operationFlag === 'ADD') {
      this.appService.createQmsNotificationSettings(payload).subscribe({
        next: (response: any) => this.handleApiResponse(response),
        error: (error: any) => this.handleApiError(error)
      });
    } else {
      payload.notificationId = this.editNotificationId;
      this.appService.updateQmsNotificationSettings(payload).subscribe({
        next: (response: any) => this.handleApiResponse(response),
        error: (error: any) => this.handleApiError(error)
      });
    }
  }

  // --- HELPER METHODS ---

  private isValidForm(): boolean {
    const isMissingCommonFields = !this.selectedModuleValue ||
      this.selectedGroupList.length === 0 ||
      (this.visibleEditButton && !this.qmsNotificationSettingsFieldData.updateReason);

    if (this.selectedMainModuleValue === 'CC') {
      return !isMissingCommonFields;
    } else {
      return !isMissingCommonFields && !!this.selectedModuleType;
    }
  }
  focusEmpty() {
    console.log();
  }
  private preparePayload(fieldData: any): any {
    const payload = { ...fieldData };

    delete payload.createdOn;
    delete payload.updatedOn;

    payload.module = this.selectedModuleValue || null;
    payload.groupList = this.selectedGroupList.length ? this.selectedGroupList.map(String).join(",") : null;
    payload.stopEmails = payload.stopEmails ? "Y" : "N";

    // Handle module type logic
    if (this.selectedMainModuleValue === 'CC') {
      payload.moduleType = 'NA';
    } else {
      payload.moduleType = this.selectedModuleType || null;
    }

    return payload;
  }

  private handleApiResponse(response: any): void {
    this.isProcessing = false;

    if (response.resultType === 'S') {
      this.visibleAddAndEditPopup.close();
      this.getCall();
    }

    const sb = this.snackBar.openFromComponent(SuccessSnackbarComponent, {
      data: {
        message: response.result,
        type: response.resultType === 'S' ? 'Success' : 'Error',
        buttonLabel: "Ok"
      },
      horizontalPosition: 'center',
      verticalPosition: 'top',
      panelClass: response.resultType === 'S' ? 'Success' : 'Error',
    });

    sb.onAction().subscribe(() => {
      sb.dismiss();
    });
  }

  private handleApiError(error: any): void {
    this.isProcessing = false;
    throw error;
  }

  cancelAddAndEditFunction() {
    this.visibleAddAndEditPopup.close();
  }

  deleteNotificationId: any;
  openDeletePopup(deleteRowData: any) {
    this.operationFlag = 'DELETE';
    this.popupTitle = "Delete Quality Notification Settings";
    this.deleteNotificationId = deleteRowData.NOTIFICATION_ID;
    if (this.qmsNotificationSettingsFieldData.deleteReason != undefined) {
      this.qmsNotificationSettingsFieldData.deleteReason = '';
    }
    this.visibleDeletePopup = this.dialog.open(this.deletePopup, this.deletePopupConfig);
  }

  deleteReasonFieldValue: any;
  deleteValidation() {
    this.deleteReasonFieldValue = document.getElementById('deleteReason-validation') as HTMLInputElement;
    if (this.deleteFiledValue.value == '') {
      this.deleteReasonFieldValue.style.color = 'red';
    } else {
      this.deleteReasonFieldValue.style.color = '';
    }
  }

  deleteFiledValue: any;
  deleteFunction() {
    this.isProcessing = true;
    this.deleteFiledValue = document.getElementById('deleteTextarea') as HTMLInputElement;
    if (this.deleteFiledValue.value == '') {
      this.deleteValidation();
      alert('Please enter the mandatory fields...');
      this.isProcessing = false;
    } else {
      let data = {
        notificationId: this.deleteNotificationId,
        deleteReason: this.qmsNotificationSettingsFieldData.deleteReason,
      }
      this.appService.deleteQmsNotificationSettings(data).subscribe({
        next: (Response: any) => {
          if (Response.resultType == 'S') {
            this.visibleDeletePopup.close();
            this.getCall();
            this.isProcessing = false;
          }
          let sb = this.snackBar.openFromComponent(SuccessSnackbarComponent, {
            duration: 5000,
            data: {
              message: Response.result,
              type: Response.resultType == 'S' ? 'Success' : 'Error',
              buttonLabel: "Ok",
            },
            horizontalPosition: 'center',
            verticalPosition: 'top',
            panelClass: Response.resultType == 'S' ? 'Success' : 'Error',
          });
          sb.onAction().subscribe(() => {
            sb.dismiss();
          });
          this.isProcessing = false;
        }, error: (error) => {
          this.isProcessing = false;
          throw error;
        }
      });
    }
  }

  cancelDeleteFunction() {
    this.visibleDeletePopup.close();
  }

  showSnackBar(message: string, type: string) {
    const sb = this.snackBar.openFromComponent(SuccessSnackbarComponent, {
      duration: type === 'S' ? 5000 : undefined,
      data: {
        message,
        type: type === 'S' ? 'Success' : 'Error',
        buttonLabel: 'Ok',
        pageName: this.message.breadcrumbData.thirdLevel ?? this.message.breadcrumbData.secondLevel,
      },
      horizontalPosition: 'center',
      verticalPosition: 'top',
      panelClass: type === 'S' ? 'Success' : 'Error',
    });

    sb.onAction().subscribe(() => {
      sb.dismiss();
    });
  }

  searchText: any;
  searchValue: any;
  _temp: any = {};
  columnLists: any = {};
  grid: any = [];
  gridTemp: any;
  makeStickyColumns: any;
  dataTypeList: any = [];
  visibleDataGrid: boolean = false;
  itemsPerPage = 5;
  currentPage = 1;
  totalPages = 0;
  maxSize = 3;
  collectionSize: number;
  perPage = 10;
  calculateTotalPages: number;
  showingResultsText = "Showing results";
  displayingClaimsText = "Displaying claims";
  rowText = "Rows";
  showingRowsText = "Showing rows";
  private readonly users: any[];
  pager: any = {};
  pagedItems: any[];
  error = '';
  isModuleInvalid: boolean = false;
  search() {
    if (this.selectedMainModuleValue) {
      this.isModuleInvalid = false;
      this.getCall();

    } else {
      this.isModuleInvalid = true;
      this.showSnackBar('Please select the Module', 'E');
    }
  }

  getCall() {
    this.isProcessing = true;
    setTimeout(() => {
      this.isProcessing = false;
    }, 3000);
    const data = {

      gridName: "QMS_NOTIFICATION_SETTINGS",
    }
    this.appService.getDynamicGridHeaders(data).subscribe({
      next: (response: any) => {
        response.orderByClause = response.orderByClause ? response.orderByClause : "";
        this.makeStickyColumns = response.fixedFieldCnt;
        const data1: any = {

          gridName: "QMS_NOTIFICATION_SETTINGS_VW",
          tableOrViewName: response.tableOrViewName ?? "",
          columnsList: response.columnsList ?? "",
          fieldLabelsList: response.fieldLabelsList ?? "",
          invisibleColumn: response.invisibleColumn ?? "",
          orderByClause: response.orderByClause ?? "",
          fieldSizeList: response.fieldSizeList ?? "",
          columnsListarray: [],
          fieldColumnarray: [],
          invisibleColumnarray: [],
          fieldSizeListArray: [],
          manualEntryDataFields: response.manualEntryDataFields,
          module: this.selectedMainModuleValue ?? null,
          clobColumnlist: response.closblist || "",
          blobColumnlist: response.bloblist || ""
        }

        this.reportObj = { ...data1, ...data };
        this.auditTrail.secondary_obj = data1;
        this.appService.getDynamicGridData(data1).subscribe({
          next: (response1: any) => {
            this.grid = response1;
            this.visibleAuditTrail = false;
            data1.columnsListarray = data1.columnsList.split(",");
            data1.fieldColumnarray = data1.fieldLabelsList.split(",");
            data1.invisibleColumnarray = data1.invisibleColumn.split(",");
            data1.fieldSizeListArray = data1.fieldSizeList.split(",");
            this.columnLists.columnsListarray = data1.columnsListarray;
            this.columnLists.fieldLabelsList = data1.fieldLabelsList;
            this.columnLists.fieldColumnarray = [];
            for (let p = 0; p < data1.fieldColumnarray.length; p++) {
              this.columnLists.fieldColumnarray.push({
                "fieldColumnarray": data1.fieldColumnarray[p],
                "width": data1.fieldSizeListArray[p] + 'px'
              })
            }
            this.columnLists.invisibleColumnarray = data1.invisibleColumnarray;
            this.columnLists.fieldSizeListArray = [];
            for (const element of data1.fieldSizeListArray) {
              this.columnLists.fieldSizeListArray.push(element + 'px');
            }
            for (let y = 0; y < this.columnLists.columnsListarray.length; y++) {
              for (const element of this.columnLists.invisibleColumnarray) {
                if (this.columnLists.columnsListarray[y] == element) {
                  this.columnLists.columnsListarray.splice(y, 1);
                  this.columnLists.fieldColumnarray.splice(y, 1);
                  this.columnLists.fieldSizeListArray.splice(y, 1);
                }
              }
            }
            let tableData = {
              tablename: data1.tableOrViewName
            };
            this.columnLists.columnsListarray1 = [];
            this.appService.tableFieldsDataType(tableData).subscribe((response2: any) => {
              this.dataTypeList = response2;
              for (let m = 0; m < this.columnLists.columnsListarray.length; m++) {
                this.columnLists.columnsListarray1.push({});
                this.columnLists.columnsListarray1[m].columnsListarray = this.columnLists.columnsListarray[m];
                this.columnLists.columnsListarray1[m].dataType = "textbox";
                this.columnLists.columnsListarray1[m].width = this.columnLists.fieldSizeListArray;
                for (const element of this.dataTypeList) {
                  if (element.columnName == this.columnLists.columnsListarray[m]) {
                    this.columnLists.columnsListarray1[m].dataType = element.fieldType;
                  }
                }
              }
              for (const rowData of this.grid) {
                for (const element of this.dataTypeList) {
                  if (element.fieldType === 'CHECKBOX') {
                    rowData[element.columnName] = rowData[element.columnName] === 'Y';
                  }
                }
              }
              this.calculateTotalPages = this.collectionSize / this.perPage;
              this.pager.totalPages = undefined;
              this.setPage(1, 0);
            });
            this.message.gridList = this.grid;
            this.collectionSize = this.grid.length;
            this.totalPages = Math.ceil(this.grid.length / this.itemsPerPage);
            this.dynamicLabelCall();
            this.isProcessing = false;
          },
          error: (error) => {
            this.isProcessing = false;
            throw error;
          }
        });
        this.isProcessing = false;
      }, error: (error) => {
        this.isProcessing = false;
        throw error;
      }
    });
  }

  setPage(page: number, targetPage: number) {
    if (page < 1 || page > this.pager.totalPages) {
      return;
    }
    if (Number.isNaN(page)) {
      page = 1;
    }
    this.pager = this.paginationService.getPager(this.grid.length, page, this.perPage, targetPage);
    this.pagedItems = this.grid.slice(this.pager.startIndex, this.pager.endIndex + 1);
  }

  setPagedOrSearch(page: number, targetPage: number) {
    if (Number.isNaN(page)) {
      page = 1;
    }

    if (this.gridTemp.length > 0) {
      this.pager = this.paginationService.getPager(this.gridTemp.length, page, this.perPage, targetPage);
      this.pagedItems = this.gridTemp.slice(this.pager.startIndex, this.pager.endIndex + 1);
    } else {
      this.pagedItems = [];
    }
  }

  paginationCall(value: number) {
    this.perPage = value;
    this.setPage(this.pager.currentPage, 0);
  }

  applyFilter3(column: string, event: Event): void {
    const filter = (event.target as HTMLInputElement).value.trim().toLowerCase();
    if (filter === '') {
      this.pagedItems = this.grid.slice(this.pager.startIndex, this.pager.endIndex + 1);
    } else {
      this.pagedItems = this.grid.filter((item: any) =>
        item[column]?.toLowerCase().includes(filter)
      );
    }
  }


  searchValue2: any;
  applyFilter2(event: Event) {
    const filter = (event.target as HTMLInputElement).value.trim().toLowerCase();
    if (filter === '') {
      this.gridTemp = this.grid;
      this.pager = this.paginationService.getPager(this.gridTemp.length, 1, this.perPage, 0);
      this.pagedItems = this.gridTemp.slice(this.pager.startIndex, this.pager.endIndex + 1);
    } else {
      if (this.grid == undefined) {
        return this.grid;
      }
      if (!this.grid.length) {
        return this.grid;
      }
      if (filter) {
        this.gridTemp = this.grid.filter(function (item: any) {
          return JSON.stringify(item).toLowerCase().includes(filter);
        });
      } else {
        this.gridTemp = this.grid.filter(function (item: any) {
          return JSON.stringify(item).toLowerCase();
        });
      }
      this.setPagedOrSearch(1, 0);
    }
  }

  sortedColumn: string = '';
  sortDirection: string = 'asc';
  sortColumn(column: string, list: any) {
    if (column === this.sortedColumn) {
      this.sortDirection = this.sortDirection === 'asc' ? 'desc' : 'asc';
    } else {
      this.sortedColumn = column;
      this.sortDirection = 'asc';
    }
    list.showsort = this.sortDirection;

    this.grid.sort((a: { [x: string]: any; }, b: { [x: string]: any; }) => {
      const key = column;
      const valueA = a[key];
      const valueB = b[key];

      if (valueA < valueB) {
        return this.sortDirection === 'asc' ? -1 : 1;
      } else if (valueA > valueB) {
        return this.sortDirection === 'asc' ? 1 : -1;
      } else {
        return 0;
      }
    });
    this.setPage(1, 0);
  }

  counts: any;
  cssFunction(ix: number) {
    let elements1 = this.elem.nativeElement.querySelectorAll('.sticky-dynamic-col1');
    let index1 = 1;
    let headerWidth = 0;
    elements1.forEach((header: any, key: any) => {
      for (let i = 1; i <= this.makeStickyColumns; i++) {
        if (index1 == i) {
          header.style.position = 'sticky';
          header.style.background = 'white';
          if (index1 > 1) {
            headerWidth += 200;
            header.style.left = headerWidth + 'px';
          } else {
            headerWidth = 60;
            header.style.left = headerWidth + 'px';
          }
        }
      }
      index1++;
    })

    let elements2 = this.elem.nativeElement.querySelectorAll('.sticky-dynamic-row1');
    let index2 = 1;
    let lengthOfColumns = this.columnLists.columnsListarray1.length;
    let colWidth = 0;
    let p = 1;
    elements2.forEach((column: any, key: any) => {
      for (let j = 1; j <= this.makeStickyColumns; j++) {
        if (index2 == j) {
          column.style.position = 'sticky';
          p = p + 1;
          column.style.background = 'white';
          column.style.textDecoration = "underline";
          column.style.color = "blue";
          column.style.cursor = "pointer";
          if (index2 > 1) {
            colWidth += 200;
            let previousColumn = elements2[key - 1];
            console.log(previousColumn.style.width);
            column.style.left = colWidth + 'px';
          } else {
            colWidth = 60;
            column.style.left = colWidth + 'px';
          }
          column.addEventListener('click', this.onClick.bind(this));
        }
      }
      if (index2 == (lengthOfColumns - 1)) {
        index2 = 0;
      } else {
        index2++;
      }
    })
  }

  onClick(event: any) {

  }

  parentCheckBox: boolean = false;
  childCheckBox: boolean = false;
  dataGridParentCheckBoxChecked(e: any) {
    if (e.target.checked) {
      this.childCheckBox = true;
      for (const element of this.grid) {
        element.childCheckBox = true;
      }
    } else {
      this.childCheckBox = false;
      for (const element of this.grid) {
        element.childCheckBox = false;
      }
    }
  }

  previousIdx: any;
  dataGridChildCheckBoxChecked(e: any, list: any, idx: any) {
    if (e.target.checked) {
      if (this.previousIdx != undefined) {
        this.grid[this.previousIdx].childCheckBox = false;
      }
      list.childCheckBox = true;
      this.auditTrail.refNo = list.RISK_SCALE_ID;
    } else {
      list.childCheckBox = false;
    }
    this.visibleAuditTrail = this.grid.some((list: any) => list.childCheckBox);
    this.previousIdx = idx;
  }

  @ViewChild(DynamicAuditTrailComponent) dynamicAuditTrailComponent!: DynamicAuditTrailComponent;

  openAuditTrail(viewType: any, notification: any) {
    this.auditTrail.refNo = viewType == 'overAll' ? null : notification.NOTIFICATION_ID;
    this.auditTrail.gridName = 'QMS_NOTIFICATION_SETTINGS';
    this.auditTrail.report_And_Popup_Name = 'QMS Notification Settings Audit Trail';
    this.dynamicAuditTrailComponent.triggerTrail(notification);
  }

  @ViewChild(ExcelPdfComponent) excelPdfComponent!: ExcelPdfComponent;
  excelPdf: any = {};
  reportObj: any = {};

  openReport(reportType: string) {
    this.excelPdf.reportObj = this.reportObj;
    this.excelPdf.reportType = 'Dynamic';
    this.excelPdf.reportName = 'QMS Notification Settings Report';
    this.excelPdf.dropDown = this.columnLists?.fieldColumnarray?.map((item: any) => item.fieldColumnarray);
    this.excelPdfComponent.openReportPopup(reportType);
  }

  @ViewChild(GridReorderComponent) gridReorderComponent!: GridReorderComponent;
  openReorder() {
    this.gridReorderComponent.reordercall(this.reportObj.gridName, this.reportObj.tableOrViewName, null, 0)
  }

  onChildValueEmitted() {
    this.getCall();
  };

  dynamicLabel: any = null;
  label: any = [];
  dynamicLabelCall() {
    this.isProcessing = true;
    let data = {
      tableName: this.reportObj.tableOrViewName,
      moduleName: null,
      gridName: this.reportObj.gridName,
      groupId: 0,
    };
    this.appService.getreorderGirdColumnList(data).subscribe({
      next: (data: any) => {
        this.label = data;
        this.dynamicLabel = this.label.reduce((acc: any, user: any) => {
          acc[`${user.columnName}`] = user.changedFieldName;
          return acc;
        }, {});
        console.log(this.dynamicLabel)
        this.isProcessing = false;
      }, error: (error: any) => {
        this.isProcessing = false;
      }
    });
  }
}
